import React from "react";
import AddBrand from "../../components/admin/add/AddBrand";

const AddBrandPage = () => {
  return (
    <div className="admin-page">
      <AddBrand />
    </div>
  );
};

export default AddBrandPage;